export default {
        title: 'Definición de valores característicos',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
                name: 'Nombre del valor característico',
		unit: 'Unidad',
		nickname: 'Nombre en Inglés',
		placeholder: {
                        name: 'Por favor ingrese el nombre del valor característico',
			unit: 'Por favor ingrese unidad',
			nickname: 'Por favor ingrese nombre en inglés'
		}
	},
	table: {
		id: 'ID',
                name: 'Nombre del valor característico',
                unit: 'Unidad del valor característico',
		nickname: 'Nombre en Inglés',
		dimension: 'Dimensión de Datos',
		remark: 'Observación',
		sort: 'Ordenar'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	widgetForm: {
                name: 'Nombre del valor característico',
		unit: 'Unidad',
		nickname: 'Nombre en Inglés',
		dimension: 'Dimensión de Datos',
		sort: 'Ordenar',
		remark: 'Observación',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
                        name: 'Por favor ingrese el nombre del valor característico',
			unit: 'Por favor ingrese unidad',
			nickname: 'Por favor ingrese nombre en inglés'
		}
	},
	dimension: {
		value1: 'Etiqueta 1',
		value2: 'Etiqueta 2',
		value3: 'Etiqueta 3'
	}
}
